import React, { useRef, useEffect, useState } from 'react';
import {
  useWindowDimensions, WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import classnames from 'classnames';
import { SCREEN_WIDE } from '../../config/constants';

import './style.scss';

const findFirstBlockLevelParentElementRecursive = (element) => {
  if (window.getComputedStyle(element).display === 'block') {
    return element;
  }

  if (element.parentElement) {
    return findFirstBlockLevelParentElementRecursive(element.parentElement);
  }

  return null;
};

const AnchorAnnotation = ({ title, children, ...props }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef();
  const newDiv = useRef();
  const { width } = useWindowDimensions();
  const isDesktop = width > SCREEN_WIDE;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const updatePosition = () => {
    if (ref.current && newDiv.current) {
      const parent = findFirstBlockLevelParentElementRecursive(ref.current);
      if (parent) {
        const childPos = ref.current.getBoundingClientRect();
        const parentPos = parent.getBoundingClientRect();
        const childOffset = childPos.top - parentPos.top;
        newDiv.current.style.top = `${childOffset}px`;
      }
    }
    window.requestAnimationFrame(updatePosition);
  };

  useEffect(() => {
    if (ref.current) {
      const parent = findFirstBlockLevelParentElementRecursive(ref.current);
      if (parent) {

        newDiv.current = document.createElement('div');
        newDiv.current.className = 'AnchorAnnotation__desktop';

        const icon = document.createElement('i');
        icon.className = 'icon icon-link icon-variant-1';
        newDiv.current.appendChild(icon);

        const content = document.createElement('div');
        content.innerHTML = title;
        newDiv.current.appendChild(content);

        parent.style.position = 'relative';
        parent.appendChild(newDiv.current);

        updatePosition();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatePosition, ref, title]);

  let timer;

  const handleMouseOver = () => {
    clearTimeout(timer);
    const toClean = document.querySelectorAll('.annotation__show');
    if (toClean.length > 0) {
      toClean.forEach((element) => element.classList.remove('annotation__show'));
    }
    const div = newDiv.current;
    div.classList.add('annotation__show');
    timer = setTimeout(() => {
      div.classList.remove('annotation__show');
    }, 10000);
  };

  // handle mobile version
  const handleClick = (e) => {
    e.preventDefault();
    setVisible(!visible);
  };

  const className = classnames('AnchorAnnotationLink', {
    'AnchorAnnotationLink--uncollapsed': visible,
  });

  const classNameInfo = classnames('AnchorAnnotation', {
    'AnchorAnnotation--visible': visible,
  });


  if (isDesktop) {
    return (
      <a
        onMouseOver={() => handleMouseOver()}
        className="AnchorAnnotationLink__desktop"
        ref={ref}
        {...props}>{children}
      </a>
    );
  } else {
    return (
      <>
        <button type="button" className={className} onClick={handleClick} {...props}>
          <span className="AnchorAnnotationLink__content">
            <i className="icon icon-link icon-variant-1" />
            {children}
            <i className="icon icon-chevron-right" />
          </span>
        </button>
        <div className={classNameInfo}>
          <i className="icon icon-link icon-variant-1" />
          <div>
            <a {...props}>
              <WysiwygField
                property="schema:text"
                html={title}
              />
            </a>
          </div>
        </div>
      </>
    );
  }
};

export default AnchorAnnotation;
